import { RxDocument } from 'rxdb'
import { Attr, BaseSchema, IQuery, ModelSchema } from './helpers'
import { PageSchema } from './PageSchema'
import { AttributeSchema } from './AttributeSchema'
import { AttributeOptionSchema } from './AttributeOptionSchema'
import { UserSchema } from './UserSchema'

@ModelSchema({
  name: 'attribute_value',
  description: 'A type of property that can have value(s) attached to a page',
  version: 0,
  required: ['attribute_id', 'page_id'],
  indexes: ['attribute_id', 'page_id', 'option_id'],
  associations: () => [
    { type: 'belongsTo', model: PageSchema, key: 'page', foreignKey: 'page_id' },
    { type: 'hasOne', model: AttributeSchema, key: 'attribute', foreignKey: 'attribute_id' },
    { type: 'hasOne', model: AttributeOptionSchema, key: 'option', foreignKey: 'option_id' },
    { type: 'hasOne', model: PageSchema, key: 'linked_page', foreignKey: 'linked_page_id' },
    { type: 'hasOne', model: UserSchema, key: 'linked_user', foreignKey: 'linked_user_id' },
  ],
  lifecycle: {
    async fetchQuery(store, params) {
      const { selector, modifier } = params
      if (selector.page_id) {
        const { response } = await store.API.GET(`/pages/${selector.page_id}/attribute_values`, modifier)
        return response.attribute_values
      }
    },
    async onChange(store, c) {
      const { page_id, option_id } = c.documentData
      if (page_id && option_id) {
        const AttributeOptions = store.getModel(AttributeOptionSchema)
        const opt = await AttributeOptions.GET(option_id)
        if (opt && opt.inbox_status) {
          const Pages = store.getModel(PageSchema)
          Pages.UPDATE(page_id, { inbox_status: opt.inbox_status })
        }
      }
    },
  },
})
export class AttributeValueSchema extends BaseSchema {
  static QUERIES = {
    ...BaseSchema.QUERIES,
    attrs(attribute_ids: string|string[], page_ids?: string[]): IQuery {
      const base: IQuery = {
        selector: {
          attribute_id: typeof attribute_ids === 'string' ? attribute_ids : { $in: attribute_ids },
        },
      }
      if (page_ids && page_ids.length) { base.selector.page_id = { $in: page_ids }}
      return base
    },
  }

  static getValueString(val: AttributeValueDoc): string { return val.value || '' }

  @Attr({ type: 'string' }) value?: string
  @Attr({ type: 'number' }) value_num?: string
  @Attr({ type: 'boolean' }) value_bool?: string
  @Attr({ type: 'string', format: 'date-time' }) value_date?: string

  page_id: string
  attribute_id: string
  option_id?: string
  linked_page_id?: string
  linked_user_id?: string
}

export type AttributeValueDoc = RxDocument<AttributeValueSchema>

export interface IAttributeValueLookup {
  [attr_id: string]: AttributeValueDoc[]
}
